import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux'
import endpoints, { getBackendUrl, apiRequest } from '../../endpoints';
import axios from 'axios';
import EditUserModal from './modals/EditUserModal'
import UsersTable from './tables/UsersTable';
import Confirmation from './modals/Confirmation';
import withAlert from '../../hoc/withAlerts'
import { setHeader } from '../../redux/headerSlice'
import Grow from '@mui/material/Grow';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

function Users(props) {
    const token = useSelector((state) => state.auth.token)
    const role = useSelector((state) => state.auth.userdata.role)
    const userId = useSelector((state) => state.auth.userdata.id)

    const [list, setList] = useState(null)
    const [filterStatus, setFilterStatus] = useState('active');
    const [rolesList, setRolesList] = useState([])
    const [dialogData, setDialogData] = useState(null)
    const [deleteItem, setDeleteItem] = useState()
    
    const dispatch = useDispatch()
    
    useEffect(() => {
        getList()
    }, [filterStatus])
    
    const userConnectionsHandler = () => {
        getList()
    }

    useEffect(() => {
        getList();
        getRolesList();
        dispatch(setHeader({
            title: 'Users'
        }))
        
        window.addEventListener('USER_DISCONNECTED', userConnectionsHandler)
        return () => {
            window.removeEventListener('USER_DISCONNECTED', userConnectionsHandler)
        }
    }, []);

    const getList = async () => {
        let uri = getBackendUrl(endpoints.users, token)
        
        const params = {
            status: filterStatus,
        }

        try {
            let res = await axios.get(uri, {params: params})
            setList(res.data.items)
        } catch (e) {
            setList([])
            showAlertError('Unknown Error - get list')
        }
    }

    const getRolesList = async () => {
        let uri = getBackendUrl(endpoints.roles, token)

        try {
            let res = await axios.get(uri)
            setRolesList(res.data.items)
        } catch (e) {
            setList([])
            showAlertError('Unknown Error - get roles list')
        }
    }

    const saveHandle = (data) => {
        setDialogData(null)
        getList()
    }

    const deleteHandle = async (response) => {
        if (response) {
            try {
                await apiRequest('delete', endpoints.users_delete, {
                    token: token,
                    id: deleteItem.id,
                })
                await getList()
                showAlertSuccess('User deleted successfully!')
            } catch (e) {
                showAlertError('Unknown Error - delete User')
            }
        }
        setDeleteItem(null)
    }

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    return (
        <Grow in={list ? true : false}>
            <Stack sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '20px' }}>
                <Stack alignItems="center" direction="row" sx={{justifyContent: 'center'}}>
                    <RadioGroup row onChange={(e) => {setFilterStatus(e.target.value)}} value={filterStatus}>
                        <FormControlLabel value="active" control={<Radio size="small" />} label="Active Users" />
                        <FormControlLabel value="inactive" control={<Radio size="small" />} label="Inactive Users" />
                        <FormControlLabel value="all" control={<Radio size="small" />} label="All Users" />
                    </RadioGroup>
                </Stack>
                <Stack>
                    <UsersTable
                        items={list}
                        btnEditHandle={(item) => {setDialogData(item)}}
                        btnDeleteHandle={(item) => {setDeleteItem(item)}}
                        authUserRole={role}
                        authUserId={userId} />
                </Stack>
                <EditUserModal
                    roles={rolesList}
                    dialogData={dialogData}
                    onClose={ () => {setDialogData(null)} }
                    onSave={saveHandle}
                />
                <Confirmation
                    data={deleteItem}
                    onResponse={deleteHandle}
                    title="Delete User"
                    content="This will permanently delete the user. This cannot be undone. To temporarily block access instead, edit the user and set status to Inactive."
                />
            </Stack>
        </Grow>
    );
}

export default withAlert(Users)